/// <reference types="googlemaps" />
import { Component, ViewChild, ElementRef, AfterViewInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Countries } from '../../utils/countries-enum';
declare const google: any;
@Component({
  selector: 'iv-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss'],
})
export class GoogleMapComponent implements AfterViewInit, OnChanges {
  @Input() position: google.maps.LatLng;
  @ViewChild('mapContainer', { static: true }) gmap: ElementRef;
  map: google.maps.Map;
  lat: number;
  lng: number;
  zoom: number = 5.0;
  mapOptions: google.maps.MapOptions;
  marker: google.maps.Marker;

  constructor() {
    const userLocale = window.localStorage.getItem('user_locale');
    switch (userLocale) {
      case 'cn':
      case 'zh':
        // Lat lng for China
        this.lat = 39.9890;
        this.lng = 116.3207;
        break;
      case 'zh-Hant':
        // Lat lng for Taiwan
        this.lat = 23.6978;
        this.lng = 120.9605;
        break;
      case 'en-IN':
        // Lat lng for India
        this.lat = 22.654826;
        this.lng = 80.084126;
        break;
      default:
        switch (window.localStorage.getItem('country')) {
          case Countries.Korea:
            // Lat lng for Korea
            this.lat = 35.9078;
            this.lng = 127.7669;
            break;
          case Countries.Taiwan:
            this.lat = 23.6978;
            this.lng = 120.9605;
            break;
          // Lat lng for Thailand
          case Countries.Thailand:
            this.lat = 13.736717;
            this.lng = 100.523186;
            break;
          // Lat lng for Philippines  
          case Countries.Philippines:
            this.lat = 14.5995;
            this.lng = 120.9842;
            break;
          // Lat lng for Vietnam
          case Countries.Vietnam:
            this.lat = 14.0583;
            this.lng = 108.2772;
            break;
          default:
            // Lat lng for APAC area
            this.lat = 30.3513981;
            this.lng = 77.3223253;
            this.zoom = 1.0;
            break;
        }
        break;
    }
  }

  mapInitializer() {
    this.mapOptions = {
      center: new google.maps.LatLng(this.lat, this.lng),
      streetViewControl: false,
      mapTypeControl: false,
      zoomControl: true,
      zoom: this.zoom
    };
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
    this.marker = new google.maps.Marker({
      map: this.map
    });
    if (this.position) {
      this.setMarker();
    }
  }

  ngAfterViewInit() {
    this.mapInitializer();
  }

  setMarker() {
    this.map.setZoom(17);
    this.map.setCenter(this.position);
    this.marker.setPosition(this.position);
    this.marker.setMap(this.map);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.position.currentValue) {
      this.setMarker();
    } else if (changes && changes.position.currentValue === null) {
      this.marker.setMap(null);
      this.mapInitializer();
    }
  }
}
